import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './UserOptions.module.css';
import udiDatamatrix from '../../assets/udi-datamatrix.png';
import snLabel from '../../assets/sn-label.png';
import serialBarcode from '../../assets/serial-barcode.png';
import manufacturerIcon from '../../assets/manufacturer-icon.png';

/**
 * Manufacturer and FDA-required device/software information
 */
const MANUFACTURER_INFO = {
  softwareName: 'Perin Health System - Provider Dashboard',
  company: {
    name: 'Perin Health Devices, LLC',
    addressLine1: '755 Research Parkway, Suite 530',
    addressLine2: 'Oklahoma City, OK 73104',
    website: 'www.perinhealth.com',
  },
};

const ManufacturerInformationModal = ({ show, handleClose }) => {
  const { company, softwareName } = MANUFACTURER_INFO;

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Manufacturer Information</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.formContactInfo}>
        {/* Product name */}
        <div style={{ fontWeight: 600, marginBottom: '0.5rem' }}>{softwareName}</div>
        <div style={{ marginBottom: '0.5rem', fontStyle: 'italic', color: '#4F4F4F' }}>
          For use by a healthcare professional only.
        </div>

        {/* Company information */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.25rem' }}>
          <img
            src={manufacturerIcon}
            alt=""
            style={{ height: 48, width: 'auto', flexShrink: 0 }}
          />
          <div>
            <div style={{ fontWeight: 550 }}>{company.name}</div>
            <div>{company.addressLine1}</div>
            <div>{company.addressLine2}</div>
            <div>
              <a href={`https://${company.website}`} target="_blank" rel="noopener noreferrer">
                {company.website}
              </a>
            </div>
          </div>
        </div>

        {/* Device identification */}
        <div style={{ borderTop: '1px solid #eee', paddingTop: '1rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', fontSize: '14px' }}>
            <div>
              <img
                src={udiDatamatrix}
                alt="UDI Data Matrix"
                style={{ height: 64, width: 'auto', display: 'block' }}
              />
            </div>
            {/* SN: label image + barcode */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0rem', flexWrap: 'wrap' }}>
              <img
                src={snLabel}
                alt="SN"
                style={{ height: 26, width: 'auto', display: 'block' }}
              />
              <img
                src={serialBarcode}
                alt="Serial number barcode"
                style={{ height: 44, width: 'auto', display: 'block' }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ManufacturerInformationModal;
